import { ApplicationError } from '@msdk/forms'
import { styled } from '@msdk/ui'
import { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  path: string
  children?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

const FallbackWrapper = styled('div')`
  display: flex;
  width: 100vw;
  height: 100vh;
`

const Content = styled('div')`
  display: flex;
  margin-left: auto;
  margin-right: auto;
`
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  }

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error(error, errorInfo)
  }

  public componentDidUpdate({ path }: Readonly<Props>): void {
    if (path !== this.props.path) {
      this.setState({ hasError: false })
    }
  }

  public render() {
    if (this.state.hasError) {
      return (
        <FallbackWrapper id="error-boundary">
          <Content>
            <ApplicationError type="GeneralError" />
          </Content>
        </FallbackWrapper>
      )
    }

    return this.props.children
  }
}
